// extracted by css-extract-rspack-plugin
export default {"installableAppCardList":"installableAppCardList__q8i8w","installableAppCardListContainer":"installableAppCardListContainer__VHv2q"};